$('.main-menu').find('.main-menu__item-sub').last().addClass('main-menu__item-sub_last')

$('.main-header__button').click(function () {
    if ($(this).hasClass('active')) {
        closeMainMenu()
        closeMainSubmenu()
    } else {
        openMainMenu()
    }
})

$(document).on('click', '.js_main-header__club', function() {
    const modalType = $(this).attr('data-modal')
    $(`.js_club-modal[data-modal=${modalType}]`).addClass('active')
})

$('.main-menu__button').click(function () {
    if ($(this).hasClass('active')) {
        closeMainSubmenu()
    } else {
        let isActive = false
        $('.main-submenu').each((i, el) => {
            $(el).hasClass('active') ? isActive = true : ''
        })
        if (isActive) {
            closeMainSubmenu(true)
            setTimeout(() => {
                openMainSubmenu($(this))
            }, 300)
        } else {
            openMainSubmenu($(this))
        }
    }
})

$('.main-submenu__close').click(function () {
    closeMainSubmenu(false, true)
})

whiteHeaderMobile()
$(window).on('resize', function () {
    whiteHeaderMobile()
})

$('.js_main-header__search-open').on('click', function () {
    if ($(this).hasClass('active')) {
        closeSearch()
    } else {
        openSearch()
    }
})

$('.js_main-header__search-close').on('click', function () {
    closeSearch()
})

$(document).on('click', function (e) {
    if ($(e.target).closest('.header').length == 0) {
        closeSearch()
        closeHeaderCategories()
    }
})

$(document).on('click', '.js_main-header__autorization-open, .js_goods__wishlist-register', function () {
    $('.js_autorization-modal').addClass('active')
    window.autorizationModal()
    $('body').css('overflow', 'hidden')
})

if ($(window).scrollTop() > 0) {
    $('.header').addClass('main-header_white')
    $('.main-header__visible').addClass('shadow')
    $('.js_header__note').css('display', 'none')
}

$(window).on('scroll', function () {
    if (!$('.header').hasClass('header_white') && $(window).scrollTop() > 0) {
        $('.header').addClass('main-header_white')
        $('.main-header__visible').addClass('shadow')
    } else {
        if (!$('.js_main-header__search-container').hasClass('active') && !$('.js_main-header__cat-wrapper').hasClass('active')) {
            $('.header').removeClass('main-header_white')
            $('main-header__visible').removeClass('shadow')
        }
    }
    if ($(window).scrollTop() > 0) {
        $('.main-header__visible').addClass('shadow')
        $('.js_header__note').slideUp(300)
    } else {
        $('.main-header__visible').removeClass('shadow')
        $('.js_header__note').slideDown(300)
    }
})

function openMainMenu() {
    $('.main-header').addClass('active')
    $('.main-header__button').addClass('active')
    $('.main-header__visible').addClass('active')
    $('.main-header__closed').addClass('active')
    $('.main__header').addClass('active')
    closeSearch(0)
    closeHeaderCategories(0)
    let count = 0
    $('.main-menu__item').each((i, el) => {
        setTimeout(() => {
            $(el).addClass('active')
        }, count)
        count += 200
    })
    $('.main-menu__links-item').each((i, el) => {
        setTimeout(() => {
            $(el).addClass('active')
        }, count)
        count += 200
    })
    $('.main-langs__item').each((i, el) => {
        setTimeout(() => {
            $(el).addClass('active')
        }, count)
        count += 200
    })
    setTimeout(() => {
        $('.main-aside__search').addClass('active')
    }, count)
    count += 200
    $('body').css('overflow', 'hidden')
}

function closeMainMenu() {
    closeMainSubmenu()
    $('.main-header').removeClass('active')
    $('.main-header__button').removeClass('active')
    $('.main-header__visible').removeClass('active')
    $('.main-header__closed').removeClass('active')
    $('.main__header').removeClass('active')
    $('.main-menu__item').removeClass('active')
    $('.main-menu__links-item').removeClass('active')
    $('.main-langs__item').removeClass('active')
    $('.main-aside__search').removeClass('active')
    $('body').removeAttr('style')
}

function openMainSubmenu(target) {
    target.addClass('active')
    $('.main-header__menu').addClass('active')
    let submenu = target.next('.main-submenu').addClass('active')
    let count = 1000
    setTimeout(() => {
        $('.main-submenu__title').addClass('active')
    }, count)
    submenu.find('.main-submenu__item').each((i, el) => {
        setTimeout(() => {
            $(el).addClass('active')
        }, count)
        count += 200
    })
    count += 500
    setTimeout(() => {
        $('.main-menu__line').addClass('active')
    }, count)
}

function closeMainSubmenu(isActive, isTablet) {
    if (isTablet) {
        $('.main-menu__line').removeClass('active')
        $('.main-submenu__item').removeClass('active')
        $('.main-submenu').removeClass('active')
        $('.main-menu__button').removeClass('active')
        $('.main-submenu__title').removeClass('active')
        setTimeout(() => {
            !isActive ? $('.main-header__menu').removeClass('active') : ''
        }, 500)
    } else {
        $('.main-submenu__item').removeClass('active')
        setTimeout(() => {
            $('.main-submenu').removeClass('active')
            $('.main-menu__line').removeClass('active')
            $('.main-menu__button').removeClass('active')
            $('.main-submenu__title').removeClass('active')
        }, 200)
        !isActive ? $('.main-header__menu').removeClass('active') : ''
    }
}

function whiteHeaderMobile() {
    if ($(window).outerWidth() < 568) {
        $('.js__portfolio-header').addClass('header_white')
        $('.js__portfolio-header').removeClass('color-mix')
    } else {
        $('.js__portfolio-header').removeClass('header_white')
        $('.js__portfolio-header').addClass('color-mix')
    }
}

//Открытие поиска
function openSearch() {
    if ($('.js_main-header__categories').hasClass('active')) {
        closeHeaderCategories()
    }
    if (!$('.header').hasClass('header_white')) {
        $('.header').addClass('main-header_white')
    }
    $('.js_main-header__search-open').addClass('active')
    $('.js_main-header__search-open').fadeOut()
    $('.js_main-header__search-container').addClass('active')
    $('.js_main-header__search-wrapper').slideDown(300)
}

function closeSearch(duration = 400) {
    if ($('.js_main-header__search-open').hasClass('active')) {
        if ($(window).scrollTop() == 0) {
            setTimeout(function () {
                $('.header').removeClass('main-header_white')
            }, duration)
        }
        // $('.header').removeClass('main-header_white')
        $('.js_main-header__search-open').removeClass('active')
        $('.js_main-header__search-open').fadeIn(duration)
        $('.js_main-header__search-container').removeClass('active')
        $('.js_main-header__search-wrapper').slideUp(duration)
    }
}

//Открытие категорий в хедере
$(document).on('click', '.js_main-header__categories', function () {
    if ($('.js_main-header__categories').hasClass('active')) {
        if ($(window).scrollTop() == 0) {
            setTimeout(function () {
                $('.header').removeClass('main-header_white')
            }, 400)
        }
        closeHeaderCategories()
    } else {
        if ($('.js_main-header__search-open').hasClass('active')) {
            closeSearch(0)
        }
        openHeaderCategories()
    }
})

function openHeaderCategories() {
    setTimeout(function () {
        $('.header').addClass('main-header_white')
    }, 0)
    $('.js_main-header__cat-wrapper').slideDown()
    $('.js_main-header__categories').addClass('active')
    $('.js_main-header__cat-wrapper').addClass('active')
}

function closeHeaderCategories(delay = 400) {
    $('.js_main-header__cat-wrapper').slideUp(delay)
    $('.js_main-header__categories').removeClass('active')
    $('.js_main-header__cat-wrapper').removeClass('active')
    setTimeout(() => {
        activateHeaderCategory()
    }, 400)
}

activateHeaderCategory()
$(document).on('click', '.js_main-header__cat-main-button', function () {
    if (!$(this).hasClass('active')) {
        activateHeaderCategory($(this))
    }
})

function activateHeaderCategory(activeEl) {
    $('.js_main-header__cat-main-button').removeClass('active')
    $('.js_main-header__cat-sub-holder').removeClass('active')
    $('.js_main-header__cat-image-holder').removeClass('active')
    if (activeEl) {
        activeEl.addClass('active')
    } else {
        $('.js_main-header__cat-main-button').eq(0).addClass('active')
    }
    let activeTab = $('.js_main-header__cat-main-button.active').attr('data-cat')
    $(`.js_main-header__cat-sub-holder[data-cat='${activeTab}']`).addClass('active')
    $(`.js_main-header__cat-image-holder[data-cat='${activeTab}']`).addClass('active')
}

new Swiper('.js_header__note-slider', {
    slidesPerView: 1,
    speed: 1000,
    direction: 'vertical',
    autoplay:  {
        delay: 4000,
        disableOnInteraction: false,
    },
    allowTouchMove: false,
    simulateTouch: false,
    loop: true,
    modules: [SwiperModes.Autoplay]
})